import * as Yup from "yup";
import countries from "../../../utils/countries.json";
import countryIDNames from "../../../utils/countryIDNames.json"
import { t } from "../../../utils/i18n";

export const validationSchema = Yup.object({
  address: Yup.string()
    .required(() => t("account.verification.modal.address_required"))
    .min(2, () => t("account.verification.modal.address_min")),
  city: Yup.string()
    .required(() => t("account.verification.modal.city_required"))
    .min(2, () => t("account.verification.modal.city_min")),
  state: Yup.string().required(() => t("account.verification.modal.state_required")),
  country: Yup.string().required(() => t("account.verification.modal.country_required")),
  nationalIDNumber: Yup.string()
    .required(() => t("account.verification.modal.field_required")),
  phone: Yup.string()
    .required(() => t("account.verification.modal.phone_required"))
    .min(10, () => t("account.verification.modal.phone_invalid")),
  zipCode: Yup.string()
    .required(() => t("account.verification.modal.zip_required"))
});

export const countryOptions = countries
  .map((country) => {
    return {
      value: country.code2,
      label: country.name,
    };
  });

export const findCountryID = (country) => {
  const selectedCountry = countryIDNames
  .find((element) => element.country.toLowerCase() === country.toLowerCase())
  return selectedCountry
}
